import { connect } from 'react-redux'
import { selectClientFetchId } from 'src/store/selectors/client'
import { selectMarketExploreRoute } from 'src/store/selectors/layout'
import { PATH_HELPERS } from 'src/constants/navigation'

const withToMarketExplore = connect(
  state => ({
    to: selectMarketExploreRoute(state),
    destination: PATH_HELPERS.markets.buildPath(
      selectClientFetchId(state),
      '/explore'
    )
  }),
  () => ({})
)

export default withToMarketExplore
